<h2 mat-dialog-title [ngStyle]="{ 'margin-top' : data.customerId > 0 ? '120px' : '40px' }">{{data.customerId > 0 ? 'Edit' : 'Add'}} Customer</h2>
<mat-dialog-content>
    <add-customer [customerId]="data.customerId" (savedCustomer)="savedCustomer($event)">Loading</add-customer>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="btn btn-secondary" (click)="cancel()" style="float: right">Close</button>
</mat-dialog-actions>
